import { render } from "./Kontakty.vue?vue&type=template&id=5741dafa&ts=true"
import script from "./Kontakty.vue?vue&type=script&lang=ts"
export * from "./Kontakty.vue?vue&type=script&lang=ts"

import exportComponent from "G:\\Storage\\VSCodeProjects\\MineMCPay\\minemcpay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__